var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1390_557)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6224 21.3421C36.342 19.059 33.3093 17.8011 30.0784 17.7998C23.4207 17.7998 18.0024 23.218 17.9998 29.8774C17.9989 32.0062 18.555 34.0842 19.612 35.9159L17.8984 42.1748L24.3015 40.4952C26.0658 41.4576 28.0521 41.9647 30.0734 41.9653H30.0785C36.7354 41.9653 42.1543 36.5467 42.1568 29.887C42.1581 26.6595 40.9029 23.625 38.6224 21.3421ZM30.0784 39.9255H30.0742C28.2728 39.9248 26.5062 39.4407 24.9646 38.5261L24.5981 38.3085L20.7985 39.3053L21.8127 35.6007L21.5739 35.2208C20.5689 33.6224 20.0382 31.775 20.0391 29.8781C20.0412 24.343 24.5449 19.8398 30.0824 19.8398C32.7639 19.8407 35.2845 20.8863 37.1799 22.7839C39.0753 24.6815 40.1185 27.2038 40.1176 29.8863C40.1152 35.4218 35.6118 39.9255 30.0784 39.9255ZM35.585 32.4067C35.2833 32.2555 33.7995 31.5256 33.5227 31.4248C33.2463 31.324 33.0449 31.2739 32.8439 31.5759C32.6426 31.8779 32.0643 32.5578 31.8882 32.7591C31.712 32.9605 31.5362 32.9858 31.2343 32.8347C30.9325 32.6837 29.9601 32.3648 28.8072 31.3367C27.9101 30.5364 27.3045 29.5481 27.1283 29.2461C26.9525 28.9438 27.1268 28.7962 27.2607 28.6302C27.5874 28.2245 27.9146 27.7991 28.0152 27.5979C28.1159 27.3964 28.0654 27.2201 27.9899 27.0691C27.9146 26.9181 27.311 25.4326 27.0596 24.8281C26.8144 24.2399 26.5658 24.3193 26.3804 24.3101C26.2046 24.3013 26.0033 24.2996 25.802 24.2996C25.6009 24.2996 25.2739 24.375 24.9972 24.6773C24.7206 24.9795 23.941 25.7095 23.941 27.195C23.941 28.6805 25.0224 30.1155 25.1733 30.317C25.3242 30.5184 27.3015 33.5668 30.3289 34.8739C31.0489 35.1851 31.611 35.3707 32.0494 35.5098C32.7725 35.7395 33.4302 35.707 33.9503 35.6294C34.5302 35.5426 35.7357 34.8992 35.9875 34.1943C36.2389 33.4893 36.2389 32.8851 36.1633 32.7591C36.088 32.6332 35.8868 32.5578 35.585 32.4067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1390_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.99428797b65b41edadb9303ad02cd93b.svg";
export { ForwardRef as ReactComponent };